import { useEffect } from 'react';
import { NavigateFunction } from 'react-router-dom';

export const useWorkflowNavigation = (
  workflowId: string | null | undefined, 
  navigate: NavigateFunction, 
  urlClientId: string | undefined, 
  setClientId: (id: string) => void
) => {
  // Redirect if no workflow ID is provided
  useEffect(() => {
    if (!workflowId) {
      navigate('/');
    }
  }, [workflowId, navigate]);
  
  // When component mounts, set client ID from URL parameter
  useEffect(() => {
    if (urlClientId) {
      setClientId(urlClientId);
    }
  }, [urlClientId, setClientId]);
};

export default useWorkflowNavigation;
